import React from 'react';
import { useOrientations } from "@common/hooks/useOrientation";

import styles from './EventPlugImage.module.scss';

export const EventPlugImage = () => {
  const orientation = useOrientations();

  return (
    <picture>
      <source
        srcSet='/images/eventPlug/desktop.png'
        media='(min-width: 1200px)'
      />
      <source
        srcSet='/images/eventPlug/tablet.png'
        media='(min-width: 768px) and (max-width: 1199px)'
      />
      <source
        srcSet='/images/eventPlug/mobile.png'
        media='(max-width: 767px)'
      />

      {orientation !== "mobile" && (
        <img className={styles.img} srcSet='/images/eventPlug/desktop.png' alt="plug img" />
      )}
      {orientation === "mobile" && (
        <img className={styles.img} srcSet='/images/eventPlug/mobile.png' alt="plug img" />
      )}
    </picture>
  );
};
